import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';
import { HelpToggletip } from 'ui/tooltip';
import { selectFeatureFlags } from 'core/userContext';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { getIsEditMode } from 'modules/templateEditor/common/utils';
import { CustomPayloadField as Edit } from './CustomPayloadField';
import { CustomPayloadPreview as Preview } from './CustomPayloadPreview';

const FormFieldSpaced = styled(FormField)`
  margin-top: ${spacing.base};
`;

const LabelRow = styled.div`
  align-items: center;
  display: inline-flex;
  > *:first-child {
    margin-right: ${spacing.quarter};
    white-space: nowrap;
  }
`;

export const DISPLAY_CONTENT = {
  label: 'Custom fields (JSON)',
  tooltip: 'Only sent to custom email platforms',
};

export const CustomPayloadSection = () => {
  const { CustomMTAPayloads = false } = useSelector(selectFeatureFlags);

  const { isEditMode: isEditModeContext } = useEditableFieldsContext();
  const { view } = useQueryParamContext();

  const isEditModeVisible = getIsEditMode(view, isEditModeContext);

  if (!CustomMTAPayloads) return null;
  return (
    <FormFieldSpaced
      isHorizontalLayout
      labelText={
        <LabelRow>
          <span>{DISPLAY_CONTENT.label}</span>
          <HelpToggletip tooltipContent={DISPLAY_CONTENT.tooltip} />
        </LabelRow>
      }
    >
      {isEditModeVisible ? <Edit /> : <Preview />}
    </FormFieldSpaced>
  );
};
